// extracted by mini-css-extract-plugin
export default {"root":"sideNav-module--root--pHBjx","menu":"sideNav-module--menu--DWUvx"};